// TypeScript типы и интерфейсы для модуля геолокации

export interface GeolocationData {
  username: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  address?: string | null;
  timestamp?: string;
  ip_address?: string | null;
  user_agent?: string | null;
  guid?: string | null;
}

export interface GeolocationState {
  isChecking: boolean;
  hasLocation: boolean;
  isRequesting: boolean;
  error: string | null;
  showDialog: boolean;
}

export interface GeolocationPosition {
  latitude: number;
  longitude: number;
  accuracy: number;
}

export interface GeolocationError {
  code: number;
  message: string;
}

export enum GeolocationErrorCode {
  PERMISSION_DENIED = 1,
  POSITION_UNAVAILABLE = 2,
  TIMEOUT = 3
}

export interface GeolocationCheckResponse {
  success: boolean;
  hasLocation: boolean;
  lastUpdate?: string;
}

export interface GeolocationSaveResponse {
  success: boolean;
  message: string;
}

export interface AddressResponse {
  success: boolean;
  address?: string;
  details?: {
    city?: string;
    country?: string;
    road?: string;
  };
}

export interface GeolocationManagerProps {
  username: string;
  guid?: string | null; 
  children: React.ReactNode;
}

